export default "__VITE_ASSET__BXsaqlaj__"